import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';

const DisclaimerPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Simple Back Button */}
      <div className="container mx-auto px-4 py-6">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-700 transition-colors font-medium"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Home
        </Link>
      </div>

      <div className="flex-grow px-4 pb-8">
        <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Legal Disclaimer</h1>
          
          <div className="space-y-6 text-gray-700">
            <section className="pb-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-purple-700 mb-3 flex items-center gap-2">
                <span className="text-amber-500">⚠️</span> Not Medical Advice
              </h2>
              <p>
                TinnitusTune is a self-help tool that helps identify tinnitus frequencies 
                and provides notched sound therapy based on research. It is not medical advice, 
                diagnosis, or treatment. This tool has not been evaluated by the FDA or any 
                medical regulatory body.
              </p>
            </section>

            <section className="pb-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-purple-700 mb-3 flex items-center gap-2">
                <span>👨‍⚕️</span> Consult Healthcare Professionals
              </h2>
              <p>
                Always consult qualified healthcare professionals for tinnitus evaluation and treatment. 
                Never delay seeking medical advice because of something you've learned from this tool.
              </p>
            </section>

            <section className="pb-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-purple-700 mb-3 flex items-center gap-2">
                <span>📊</span> Privacy & Data
              </h2>
              <p>
                We use Google Analytics to understand general usage patterns. Your audio and frequency 
                data stay entirely in your browser and are never transmitted to any server. 
                No personal health information is collected or stored.
              </p>
            </section>

            <section className="pb-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-purple-700 mb-3 flex items-center gap-2">
                <span>⚖️</span> Use at Your Own Risk
              </h2>
              <p>
                By using TinnitusTune, you acknowledge that results vary by individual and we are not 
                liable for any outcomes. This tool is provided "as is" for educational purposes only.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-purple-700 mb-3 flex items-center gap-2">
                <span>📧</span> Questions?
              </h2>
              <p>
                For questions about this disclaimer or our tools, please visit{' '}
                <a href="https://soepel.it" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700 underline">
                  Soepel IT
                </a>.
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-6">
              Last updated: {new Date().toLocaleDateString()}
            </p>
            <Link 
              to="/" 
              className="inline-block bg-gradient-to-r from-purple-600 to-pink-500 text-white px-6 py-3 rounded-full hover:shadow-lg transition-all duration-200 transform hover:scale-105 font-semibold"
            >
              I Understand - Back to App
            </Link>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default DisclaimerPage;